module.exports = __webpack_public_path__ + "img/modal-bg-dashboard.bb14bad8.png";